module.exports = __webpack_public_path__ + "static/media/beep-07.d932c606.mp3";